import React from 'react';
import { Typography, Box } from '@mui/material';

const MpiCustomRowInput = ({ item, handleCellEdit, canEditField }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  const userName = item.name_by_uid
    ? item.name_by_uid.split('@')[0] || 'iPacketAdmin'
    : '';

  return (
    <Box>
      <Typography variant="body2">{item.name || 'Enter name...'}</Typography>
      {item.name && item.name_by_uid && (
        <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#555', fontWeight: 500 }}>
          {userName} <br /> {formatDate(item.name_by_date)}
        </Typography>
      )}
    </Box>
  );
};

export default MpiCustomRowInput;